export const DEMOGRAPHIES = "demographies"
export const LOANS = "loans"
export const LOCAL_AUTHORITIES = "localauthorities"
export const PPIS = "ppis"
export const RESETTING = "resetting"
export const SCENARII = "scenarios"
export const TITLES = "titles"
export const USERS = "users"
export const REGIONS="regions"

const UrlSegment = {
	DEMOGRAPHIES,
	LOANS,
	LOCAL_AUTHORITIES,
	SCENARII,
	USERS,
	REGIONS
}

export default UrlSegment



// WEBPACK FOOTER //
// ./src/service/sfp/constant/url-segment.ts